import React from 'react';
import InfoView from 'components/InfoView';


class Success extends React.Component {
  constructor() {
    super();
    const search = window.location.search;
const params = new URLSearchParams(search);
const foo = params.get('email');
    console.log("params",foo)
    this.state = {
      email: params.get('email') ? params.get('email') : "",
      password: ''
    }
  }

  componentDidUpdate() {
  }

  render() {
    const {
      email,
      password
    } = this.state;
    return (
      <div>
        <div style={{ textAlign: 'center', margin: '50px' }}>
            <p>Hi Guys, You are now using {email} to access AIA portal.</p>
        </div>
        <InfoView />
      </div>
    );
  }
}

export default Success;
